"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _TableCell = _interopRequireDefault(require("./TableCell"));

var TableHeaderCell =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TableHeaderCell, _PureComponent);

  function TableHeaderCell() {
    (0, _classCallCheck2.default)(this, TableHeaderCell);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableHeaderCell).apply(this, arguments));
  }

  (0, _createClass2.default)(TableHeaderCell, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_TableCell.default, (0, _extends2.default)({
        overflow: "visible",
        borderBottom: null
      }, this.props));
    }
  }]);
  return TableHeaderCell;
}(_react.PureComponent);

exports.default = TableHeaderCell;
TableHeaderCell.displayName = "TableHeaderCell";
(0, _defineProperty2.default)(TableHeaderCell, "propTypes", (0, _objectSpread2.default)({}, _TableCell.default.propTypes));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90YWJsZS9zcmMvVGFibGVIZWFkZXJDZWxsLmpzIl0sIm5hbWVzIjpbIlRhYmxlSGVhZGVyQ2VsbCIsInByb3BzIiwiUHVyZUNvbXBvbmVudCIsIlRhYmxlQ2VsbCIsInByb3BUeXBlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0lBRXFCQSxlOzs7Ozs7Ozs7Ozs7NkJBUVY7QUFDUCxhQUFPLDZCQUFDLGtCQUFEO0FBQVcsUUFBQSxRQUFRLEVBQUMsU0FBcEI7QUFBOEIsUUFBQSxZQUFZLEVBQUU7QUFBNUMsU0FBc0QsS0FBS0MsS0FBM0QsRUFBUDtBQUNEOzs7RUFWMENDLG9COzs7QUFBeEJGLGU7OEJBQUFBLGUsK0NBS2RHLG1CQUFVQyxTIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFB1cmVDb21wb25lbnQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBUYWJsZUNlbGwgZnJvbSAnLi9UYWJsZUNlbGwnXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFRhYmxlSGVhZGVyQ2VsbCBleHRlbmRzIFB1cmVDb21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIC8qKlxuICAgICAqIENvbXBvc2VzIHRoZSBUYWJsZUNlbGwgY29tcG9uZW50IGFzIHRoZSBiYXNlLlxuICAgICAqL1xuICAgIC4uLlRhYmxlQ2VsbC5wcm9wVHlwZXNcbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gPFRhYmxlQ2VsbCBvdmVyZmxvdz1cInZpc2libGVcIiBib3JkZXJCb3R0b209e251bGx9IHsuLi50aGlzLnByb3BzfSAvPlxuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/table/src/TableHeaderCell.js
// module id = 41
// module chunks = 0